import { Route, Routes  } from 'react-router-dom';
import Navbar from '../Navbar';
import Objectives from './Objectives';


function ObjectivesApp() {
  return (
    <div>
      <Navbar />  
      <Routes>
        <Route path="/" element={<Objectives />} />
      </Routes>
      {/* <Footer /> */}
    </div>
  );
}

export default ObjectivesApp;